// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yh0F","colMin":"styles_colMin__2YRPm"};